<template>
  <div class="careers">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="img-and-text">
        <img class="row-1-top-img" src="../../assets/img/careers/careers/1.jpg">
        <div class="text-group">
          <h3 class="text-accent">{{ $t('careers-1') }}</h3>
          <h1>{{ $t('careers-2') }}</h1>
          <!-- <h2>{{ $t('careers-3') }}</h2> -->
          <p>{{ $t('careers-4') }}</p>
        </div>
      </div>
      <img class="row-img" src="../../assets/img/careers/careers/2.jpg">
      <div class="right"></div>
    </div>
    <div class="row row-2">
      <img class="row-img" src="../../assets/img/careers/careers/3.jpg">
      <div class="text-group">
        <h3 class="text-accent">{{ $t('careers-5') }}</h3>
        <h1>{{ $t('careers-6') }}</h1>
        <h2>{{ $t('careers-7') }}</h2>
        <router-link to="/careers?page=internships" class="link">
          <span class="text-main-home">{{ $t('careers-8') }}</span>
        </router-link>
      </div>
    </div>
    <div class="row row-3">
      <div class="text-group">
        <h3 class="text-accent">{{ $t('careers-9') }}</h3>
        <h1>{{ $t('careers-10') }}</h1>
        <h2>{{ $t('careers-11') }}</h2>
        <router-link to="/careers?page=events" class="link">
          <span class="text-main-home">{{ $t('careers-12') }}</span>
        </router-link>
      </div>
      <img class="row-img" src="../../assets/img/careers/careers/4.jpg">
    </div>
    <Apply/>
  </div>
</template>

<script>
import Apply from "./shared/Apply";
export default {
  components: {
    Apply
  }
};
</script>

<style lang="scss" scoped>
.careers {
  position: relative;
  .row {
    z-index: 1;
    position: relative;
  }
  .row-1 {
    align-items: stretch;
    padding-bottom: 0;
    .img-and-text {
      padding-bottom: $sidesPadding / 2;
    }
    .right {
      @extend %flex-center;
      align-items: flex-end;
      background-image: url("../../assets/img/careers/careers/2.jpg");
      background-size: cover;
      background-position: center;
      flex-direction: column;
      margin-left: 3%;
      margin-top: $sidesPadding;
      width: 47%;
    }
    .row-img {
      display: none;
    }
  }
  .row-2,
  .row-3 {
    align-items: center;
    margin-top: -$sidesPadding / 4;
    img,
    .text-group {
      width: 45%;
    }
    img {
      display: block;
      height: auto;
      margin-right: 5%;
    }
    .text-group {
      padding-right: $sidesPadding;
      width: 50%;
    }
  }
  .row-3 {
    img {
      margin-right: 0;
      margin-left: 5%;
    }
    .text-group {
      padding-left: $sidesPadding;
      padding-right: 0;
    }
  }
}
@media screen and (max-width: 1600px) {
  .careers {
    .row-1 {
      .img-and-text {
        padding-bottom: $sidesPadding1600 / 2;
      }
      .right {
        margin-top: $sidesPadding1600;
      }
    }
    .row-2,
    .row-3 {
      margin-top: -$sidesPadding1600 / 4;
    }
    .row-2 {
      .text-group {
        padding-right: $sidesPadding1600;
      }
    }
    .row-3 {
      .text-group {
        padding-left: $sidesPadding1600;
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .careers {
    .row-2 {
      .text-group {
        padding: 50px 0;
        padding-right: $sidesPadding1600;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .careers {
    .row-1 {
      align-items: center;
      .img-and-text {
        img {
          display: none;
        }
        padding-bottom: 0;
        .text-group {
          margin: 0;
          padding: $sidesPadding1280;
        }
      }
      .right {
        display: none;
      }
      .row-img {
        display: block;
        height: auto;
        width: 50%;
      }
    }
    .row-2,
    .row-3 {
      margin-top: 0;
    }
    .row-2 {
      .text-group {
        padding: 50px 0;
        padding-right: $sidesPadding1280;
      }
    }
    .row-3 {
      .text-group {
        padding: $sidesPadding1280;
      }
      img {
        margin: 0;
        width: 50%;
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .careers {
    .row-1,
    .row-2,
    .row-3 {
      padding: 0;
      flex-direction: column;
      .text-group {
        width: 100%;
        padding: $sidesPadding1280;
      }
      .row-img,
      .img-and-text {
        margin: 0;
        width: 100%;
      }
      .img-and-text .text-group p:last-of-type {
        margin-bottom: 0;
      }
    }
    .row-2 {
      flex-direction: column-reverse;
    }
  }
}
@media screen and (max-width: 600px) {
  .careers {
    .row-1,
    .row-2,
    .row-3 {
      .text-group,
      .img-and-text .text-group {
        padding: $sidesPadding600;
      }
    }
  }
}
</style>
